export default {
  beforeMount(el, binding) {
    el.clickOutsideEvent = function (event) {
      if (!(el === event.target || el.contains(event.target))) {
        el.dispatchEvent(new Event('outside'));
        if (typeof binding.value === 'function') {
          binding.value(event);
        }
      }
    };

    document.body.addEventListener('mousedown', el.clickOutsideEvent);
  },
  unmounted(el) {
    document.body.removeEventListener('mousedown', el.clickOutsideEvent);
  }
};
